import HomePage from './pages/homePage/HomePage';
import ChooseVehicle from './pages/chooseVehiclePage/ChooseVehiclePage';
import PageNotFoundPage from './pages/PageNotFoundPage';
import OrderPage from "./pages/orderPage/OrderPage";
import ChooseCustomRoutePage from "./pages/chooseCustomRoutePage/ChooseCustomRoutePage";
import OrderProgressPage from "./pages/orderProgressPage/OrderProgressPage";
import LogInPage from "./pages/logInPage/LogInPage";
import RegisterPage from "./pages/registerPage/RegisterPage";
import ForgotPasswordPage from "./pages/forgotPasswordPage/ForgotPasswordPage";
import ChangePasswordPage from "./pages/changePasswordPage/ChangePasswordPage";
import ProfilePage from "./pages/profilePage/ProfilePage";
import ForgotPasswordSuccessPage from "./pages/forgotPasswordSuccessPage/ForgotPasswordSuccessPage.vue";
import ProfilePurchaseHistoryPage from "./pages/profilePurchaseHistoryPage/ProfilePurchaseHistoryPage.vue";
import ProfileSettingsPage from "./pages/profileSettingsPage/ProfileSettingsPage.vue";
import TripsPage from "./pages/tripsPage/TripsPage";
import ServicesIframePage from "./pages/servicesIframePage/servicesIframePage.vue";
import RoundTripFirstStepPage from "./pages/roundTripFirstStepPage/RoundTripFirstStepPage";
import RoundTripSecondStepPage from "./pages/roundTripSecondStepPage/RoundTripSecondStepPage";
import RoundTripFinalStepPage from "./pages/roundTripFinalStepPage/RoundTripFinalStepPage";
import TransportationTicketPage from './pages/TransportationTicketPage/TransportationTicketPage.vue';

import store from "./store/index";
import order from "./store/order.module";
import orderFalseRoundTrip from "./store/orderFalseRoundTrip.module";
import orderTrueRoundTrip from "./store/orderTrueRoundTrip.module";
import NameOfHelper from "./helpers/nameOfHelper";
import socialAuth from "./store/socialAuth.module";
import ProfileInvoicesPage from "./pages/profileInvoicesPage/profileInvoicesPage.vue";
import orderFalseDriver from "./store/orderFalseDriver.module";
import {ServiceTypes} from "./interfaces/enums/ServiceTypes.enum";
import vehicle from "./store/vehicle.module";
import orderTrueDriver from "./store/orderTrueDriver.module";



export const routesConst = {
    HOME: '/',
    CHOOSE_VEHICLE: '/choose-vehicle',
    ORDER: '/order',
    CHOOSE_CUSTOM_ROUTE: '/choose-custom-route',
    ORDER_IN_PROGRESS: '/order-in-progress',
    ORDER_COMPLETED: '/order-completed',
    ORDER_FAILED: '/order-failed',
    ORDER_REGISTERED: '/order-registered',
    LOGIN: '/login',
    GOOGLE_CALLBACK: '/auth/:provider/callback',
    FACEBOOK_CALLBACK: '/auth/:provider/callback',
    REGISTER: '/register',
    REGISTER_NEW: '/register/:hash',
    FORGOT_PASSWORD: '/forgot-password',
    FORGOT_PASSWORD_SUCCESS_PAGE: '/forgot-password-success',
    CHANGE_PASSWORD: '/change-password/:hash',
    PROFILE: '/profile',
    PROFILE_PURCHASE_HISTORY: '/profile/purchase-history',
    PROFILE_PURCHASE_HISTORY_ORDER_TICKET: '/profile/purchase-history/:orderId/ticket',
    PROFILE_INVOICES: '/profile/invoices',
    PROFILE_SETTINGS: '/profile/settings',
    ACTIVATE: '/login/:hash',
    TRIPS: '/trips',
    ROUND_TRIP_FIRST_STEP: '/round-trip-first-step',
    ROUND_TRIP_SECOND_STEP: '/round-trip-second-step',
    ROUND_TRIP_FINAL_STEP: '/round-trip-final-step',
    SERVICES_IFRAME: '/services-iframe',
    TRANSPORTATION_TICKET: '/profile/transportation-ticket',
}

export const StandAlonePages = [
    routesConst.SERVICES_IFRAME
];

export const routes = [
    {
        name: routesConst.HOME,
        path: '/',
        component: HomePage,
    },
    {
        name: routesConst.CHOOSE_VEHICLE,
        path: routesConst.CHOOSE_VEHICLE,
        component: ChooseVehicle,
        beforeEnter: handleChooseVehicleGuard
    },
    {
        name: routesConst.ORDER,
        path: routesConst.ORDER,
        component: OrderPage,
        beforeEnter: handleOrderGuard
    },
    {
        name: routesConst.CHOOSE_CUSTOM_ROUTE,
        path: routesConst.CHOOSE_CUSTOM_ROUTE,
        component: ChooseCustomRoutePage,
        beforeEnter: handleTrueDriverGuard,
    },
    {
        name: routesConst.ORDER_IN_PROGRESS,
        path: routesConst.ORDER_IN_PROGRESS,
        component: OrderProgressPage
    },
    {
        name: routesConst.ORDER_COMPLETED,
        path: routesConst.ORDER_COMPLETED,
        component: OrderProgressPage
    },
    {
        name: routesConst.ORDER_FAILED,
        path: routesConst.ORDER_FAILED,
        component: OrderProgressPage
    },
    {
        name: routesConst.ORDER_REGISTERED,
        path: routesConst.ORDER_REGISTERED,
        component: OrderProgressPage
    },
    {
        name: routesConst.LOGIN,
        path: routesConst.LOGIN,
        component: LogInPage,
        beforeEnter: handleLoginGuard,
    },
    {
        path: '/auth/:provider/callback',
        component: {
            template: '<div class="auth-component"></div>'
        }
    },
    {
        name: routesConst.REGISTER,
        path: routesConst.REGISTER,
        component: RegisterPage,
        beforeEnter: handleRegisterGuard,
    },
    {
        name: routesConst.REGISTER_NEW,
        path: routesConst.REGISTER_NEW,
        component: RegisterPage,
        beforeEnter: handleRegisterGuard,
    },
    {
        name: routesConst.FORGOT_PASSWORD,
        path: routesConst.FORGOT_PASSWORD,
        component: ForgotPasswordPage,
        beforeEnter: handleLoginGuard,
    },
    {
        name: routesConst.FORGOT_PASSWORD_SUCCESS_PAGE,
        path: routesConst.FORGOT_PASSWORD_SUCCESS_PAGE,
        component: ForgotPasswordSuccessPage,
        beforeEnter: handleLoginGuard,
    },
    {
        name: routesConst.CHANGE_PASSWORD,
        path: routesConst.CHANGE_PASSWORD,
        component: ChangePasswordPage,
        beforeEnter: handleLoginGuard,
    },
    {
        name: routesConst.ACTIVATE,
        path: routesConst.ACTIVATE,
        component: LogInPage,
        beforeEnter: handleLoginGuard,
    },
    {
        name: routesConst.PROFILE,
        path: routesConst.PROFILE,
        component: ProfilePage,
        beforeEnter: handleIsAuthenticated,
    },
    {
        name: routesConst.PROFILE_PURCHASE_HISTORY,
        path: routesConst.PROFILE_PURCHASE_HISTORY,
        component: ProfilePurchaseHistoryPage,
        beforeEnter: handleIsAuthenticated,
    },
    {
        name: routesConst.PROFILE_INVOICES,
        path: routesConst.PROFILE_INVOICES,
        component: ProfileInvoicesPage,
        beforeEnter: handleIsAuthenticated,
    },
    {
        name: routesConst.TRIPS,
        path: routesConst.TRIPS,
        component: TripsPage,
        beforeEnter: handleFalseRoundTripGuard,
    },
    {
        name: routesConst.ROUND_TRIP_FIRST_STEP,
        path: routesConst.ROUND_TRIP_FIRST_STEP,
        component: RoundTripFirstStepPage,
        beforeEnter: handleTrueRoundTripFirstStepGuard,
    },
    {
        name: routesConst.ROUND_TRIP_SECOND_STEP,
        path: routesConst.ROUND_TRIP_SECOND_STEP,
        component: RoundTripSecondStepPage,
        beforeEnter: handleTrueRoundTripSecondStepGuard,
    },
    {
        name: routesConst.ROUND_TRIP_FINAL_STEP,
        path: routesConst.ROUND_TRIP_FINAL_STEP,
        component: RoundTripFinalStepPage,
        beforeEnter: handleTrueRoundTripFinalStepGuard,
    },
    // {
    //     name: routesConst.PROFILE_PURCHASE_HISTORY_ORDER_TICKET,
    //     path: routesConst.PROFILE_PURCHASE_HISTORY_ORDER_TICKET,
    //     component: OrderTicketPage
    //     beforeEnter: handleIsAuthenticated
    // },
    {
        name: routesConst.PROFILE_SETTINGS,
        path: routesConst.PROFILE_SETTINGS,
        component: ProfileSettingsPage,
        beforeEnter: handleIsAuthenticated,
    },
    {
        name: routesConst.SERVICES_IFRAME,
        path: routesConst.SERVICES_IFRAME,
        component: ServicesIframePage,
    },
    {
        name: routesConst.TRANSPORTATION_TICKET,
        path: routesConst.TRANSPORTATION_TICKET,
        component: TransportationTicketPage,
        props: true,
    },
    {
        path: "/:pathMatch(.*)*",
        beforeEnter: (to, from, next) => {
            next({ path: '/'}); // instead 404 -> to Home page
        },
    }
];

function handleLoginGuard(to, from, next) {
    const state = socialAuth.state.enable_login_setting;

    if (state === '0') {
        next({ path: routesConst.HOME });
        return;
    }
    next();
}

function handleRegisterGuard(to, from, next) {
    const state = socialAuth.state.enable_registration_setting;

    if (state === '0') {
        next({ path: routesConst.HOME });
        return;
    }
    next();
}

function handleIsAuthenticated(to, from, next) {
    const isLoggedIn = store.getters['customer/isLoggedIn'];

    if (! isLoggedIn) {
        next({ path: routesConst.LOGIN});
        return;
    }
    next();
}

function handleFalseRoundTripGuard(to, from, next) {
    const roundTrip = order.state.roundTrip;
    const pickUp = orderFalseRoundTrip.state.pickUp.address;
    const dropOff = orderFalseRoundTrip.state.dropOff.address;

    if (!pickUp || !dropOff || roundTrip) {
        next({ path: routesConst.HOME });
        return;
    }
    next();
}

function handleTrueRoundTripFirstStepGuard(to, from, next) {
    const pickUp = orderTrueRoundTrip.state.pickUp.id
    const dropOff = orderTrueRoundTrip.state.dropOff.id;
    const tripArrivalDate = orderTrueRoundTrip.state.tripArrivalDate;
    const tripDepartureDate = orderTrueRoundTrip.state.tripDepartureDate;
    const roundTrip = order.state.roundTrip;

    if (!roundTrip || !pickUp || !dropOff || !tripArrivalDate || !tripDepartureDate) {
        next({ path: routesConst.HOME });
        return;
    }
    next();
}

function handleTrueRoundTripSecondStepGuard(to, from, next) {
    const forwardTicket = orderTrueRoundTrip.state.forwardTicket.data;
    const tripArrivalDate = orderTrueRoundTrip.state.tripArrivalDate;
    const tripDepartureDate = orderTrueRoundTrip.state.tripDepartureDate;
    const roundTrip = order.state.roundTrip;

    if ( !forwardTicket || !roundTrip || !tripArrivalDate || !tripDepartureDate ) {
        next({ path: routesConst.HOME });
        return;
    }
    next();
}

function handleTrueRoundTripFinalStepGuard(to, from, next) {
    const nameOf = (c) => NameOfHelper.obj(c);
    const forwardTicket = orderTrueRoundTrip.state.forwardTicket.data;
    const backTicket =  orderTrueRoundTrip.state.backTicket.data;
    const roundTrip = order.state.roundTrip;

    if (! forwardTicket && ! backTicket && !roundTrip) {
        next({ path: routesConst.HOME });
        return;
    }
    next();
}

function handleTrueDriverGuard(to, from, next) {
    if (!  order.state.withDriver) {
        next({ path: routesConst.HOME });
        return;
    }
    next();
}

function handleChooseVehicleGuard(to, from, next) {
    if (! orderFalseDriver.state.destination) {
        next({ path: routesConst.HOME });
        return;
    }
    next();
}

function handleOrderGuard(to, from, next) {
    const withDriver = order.state.withDriver
    const roundTrip = order.state.roundTrip;
    const serviceType = order.state.serviceType;

    let isValid = false;

    switch (serviceType) {
        case ServiceTypes.SERVICE_RENT:
            const selectedVehicleId = vehicle.state.selectedId;
            const selectedVehicle = vehicle.state.selectedVehicle;

            if (! withDriver) {
                isValid = orderFalseDriver.state.destination
                    && selectedVehicle
                    && selectedVehicleId;
            } else {
                isValid = orderTrueDriver.state.pickup
                    && orderTrueDriver.state.selectedTravelObjective
                    && selectedVehicle
                    && selectedVehicleId
                    && orderTrueDriver.state.price;
            }
            break;

        case ServiceTypes.SERVICE_TRANSPORTATION:
            if (! roundTrip) {
                isValid = orderFalseRoundTrip.state.pickUp
                    && orderFalseRoundTrip.state.dropOff
                    && orderFalseRoundTrip.state.transportationId;
            } else {
                isValid = orderTrueRoundTrip.state.pickUp
                    && orderTrueRoundTrip.state.dropOff
                    && orderTrueRoundTrip.state.forwardTicket
                    && orderTrueRoundTrip.state.backTicket;
            }
            break;
    }

    if (! isValid) {
        next({ path: routesConst.HOME });
        return;
    }
    next();


}